export { SizeAll as sizeAll } from '../../themes/default/size/index.js';

var sizeTokens = {};

export { sizeTokens };
